import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  companies: [],
  error: false,
  loading: false,
  lastSync: false,
};
const initialState = defineState(defaultState)('companies');
const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.companies.length > 0 ? action.companies : [];  
  return updateObject(state, {
    companies: result,
    error: false,
    loading: false,
    lastSync: new Date(),
  })
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, companies: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANIES_START:
      return fetchStart(state);
    case actionTypes.FETCH_COMPANIES_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_COMPANIES_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false,
      };
  }
};

export default reducer;
